import type { Theme } from '@mui/material';

export const styles = {
  step: {
    alignItems: 'center',
    textAlign: 'center',
  },

  stepCounter: (theme: Theme) => ({
    color: theme.colors.neutral[200],
    fontWeight: 'normal',
    my: 2,
  }),

  button: (theme: Theme) => ({
    margin: 'auto',
    padding: 0,
    backgroundColor: 'transparent !important',
    position: 'relative',
    overflow: 'visible',
    width: '6rem',
    height: '6rem',

    [theme.breakpoints.up('md')]: {
      width: '9.5rem',
      height: '9.5rem',
    },

    img: {
      position: 'relative',
      left: '0.25rem',
      zIndex: 1,
      height: '100%',
      width: 'auto',
    },

    '&::before': {
      content: '""',
      width: 0,
      position: 'absolute',
      top: '-0.75rem',
      border: `1px dashed ${theme.colors.neutral[200]}`,
      zIndex: 1,
      height: '0.75rem',

      [theme.breakpoints.up('md')]: {
        height: '1rem',
      },
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: theme.colors.neutral[200],
      borderRadius: '50%',
      width: '0.625rem',
      height: '0.625rem',
      zIndex: 1,
      top: 0,

      [theme.breakpoints.up('md')]: {
        top: '0.25rem',
      },
    },
  }),

  arrow: (theme: Theme) => ({
    position: 'absolute',
    top: '52%',
    height: 0,
    border: `1px dashed ${theme.colors.neutral[200]}`,
    width: '75%',
    left: 'calc(-3.5rem - 25%)',

    [theme.breakpoints.up('md')]: {
      left: 'calc(-5.5rem - 25%)',
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '100%',
      width: 0,
      height: 0,
      borderTop: '8px solid transparent',
      borderBottom: '8px solid transparent',
      borderLeft: `16px solid ${theme.colors.neutral[200]}`,
      transform: 'translate(-50%, -50%)',
    },
  }),
};
